import { Switch } from "@/components/ui/switch";
import { cn } from "@/lib/utils";

/** One surface per form; FieldGroups stack inside with hairlines between them. */
export const FormSurface = ({ children, className, testId }) => (
  <div className={cn("admin-card px-4 sm:px-5", className)} data-testid={testId}>{children}</div>
);

/**
 * Form section: title/description in a left column (desktop), fields in a 1–2 column grid on the right.
 * Keeps long forms scannable instead of a wall of inputs.
 */
export const FieldGroup = ({ title, description, children, cols = 2, aside, className, testId, stacked = false }) => (
  <section className={cn("hairline border-b py-4 last:border-b-0", className)} data-testid={testId}>
    <div className={cn("grid gap-3", (title || description) && !stacked && "lg:grid-cols-[180px_minmax(0,1fr)] lg:gap-8")}>
      {(title || description) && (
        <div className={cn("min-w-0", stacked && "flex flex-wrap items-baseline gap-x-3 gap-y-1")}>
          {title && <h3 className="text-[13px] font-semibold tracking-[-0.01em]">{title}</h3>}
          {description && <p className={cn("text-[12px] leading-relaxed text-muted-foreground", !stacked && "mt-1")}>{description}</p>}
          {aside && <div className="mt-3">{aside}</div>}
        </div>
      )}
      <div className={cn("grid min-w-0 gap-3", cols === 2 && "sm:grid-cols-2", cols === 3 && "sm:grid-cols-3")}>{children}</div>
    </div>
  </section>
);

/** Labelled switch row with optional hint. */
export const SwitchRow = ({ label, hint, checked, onCheckedChange, disabled, testId, className }) => (
  <label className={cn("admin-field flex min-h-[40px] cursor-pointer items-center justify-between gap-4 rounded-lg px-3 py-2 text-sm transition-colors", disabled && "cursor-not-allowed opacity-60", className)}>
    <span className="min-w-0">
      <span className="block text-[13px] font-medium">{label}</span>
      {hint && <span className="block text-[11.5px] text-muted-foreground">{hint}</span>}
    </span>
    <Switch checked={!!checked} onCheckedChange={onCheckedChange} disabled={disabled} data-testid={testId} />
  </label>
);
